import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LunghezzeAngolariService {

  constructor() { }
    
  getDataAngolari() {
    return [
        { "lunghezza": 20, "composizione": [20] },
        { "lunghezza": 40, "composizione": [40] },
        { "lunghezza": 60, "composizione": [60] },
        { "lunghezza": 80, "composizione": [80] },
        { "lunghezza": 100, "composizione": [100] },
        { "lunghezza": 120, "composizione": [120] },
        { "lunghezza": 140, "composizione": [140] },
        { "lunghezza": 160, "composizione": [160] },
        { "lunghezza": 180, "composizione": [180] },
        { "lunghezza": 200, "composizione": [200] },
        { "lunghezza": 220, "composizione": [220] },
        { "lunghezza": 240, "composizione": [240] },
        { "lunghezza": 260, "composizione": [260] },
        { "lunghezza": 280, "composizione": [280] },
        { "lunghezza": 300, "composizione": [300] },
        { "lunghezza": 320, "composizione": [320] },
        { "lunghezza": 340, "composizione": [160, 180] },
        { "lunghezza": 360, "composizione": [180, 180] },
        { "lunghezza": 380, "composizione": [180, 200] },
        { "lunghezza": 400, "composizione": [200, 200] },
        { "lunghezza": 420, "composizione": [200, 220] },
        { "lunghezza": 440, "composizione": [220, 220] },
        { "lunghezza": 460, "composizione": [220, 240] },
        { "lunghezza": 480, "composizione": [240, 240] },
        { "lunghezza": 500, "composizione": [240, 260] },
        { "lunghezza": 520, "composizione": [260, 260] },
        { "lunghezza": 540, "composizione": [260, 280] },
        { "lunghezza": 560, "composizione": [280, 280] },
        { "lunghezza": 580, "composizione": [280, 300] },
        { "lunghezza": 600, "composizione": [300, 300] },
        { "lunghezza": 620, "composizione": [300, 320] },
        { "lunghezza": 640, "composizione": [320, 320] },
        { "lunghezza": 660, "composizione": [220, 220, 220] },
        { "lunghezza": 680, "composizione": [220, 220, 240] },
        { "lunghezza": 700, "composizione": [220, 240, 240] },
        { "lunghezza": 720, "composizione": [240, 240, 240] },
        { "lunghezza": 740, "composizione": [240, 240, 260] },
        { "lunghezza": 760, "composizione": [240, 260, 260] },
        { "lunghezza": 780, "composizione": [260, 260, 260] },
        { "lunghezza": 800, "composizione": [260, 260, 280] },
        { "lunghezza": 820, "composizione": [260, 280, 280] },
        { "lunghezza": 840, "composizione": [280, 280, 280] },
        { "lunghezza": 860, "composizione": [280, 280, 300] },
        { "lunghezza": 880, "composizione": [280, 300, 300] },
        { "lunghezza": 900, "composizione": [300, 300, 300] },
        { "lunghezza": 920, "composizione": [300, 300, 320] },
        { "lunghezza": 940, "composizione": [300, 320, 320] },
        { "lunghezza": 960, "composizione": [320, 320, 320] },
        { "lunghezza": 980, "composizione": [240, 240, 240, 260] },
        { "lunghezza": 1000, "composizione": [240, 240, 260, 260] },
        { "lunghezza": 1020, "composizione": [240, 260, 260, 260] },
        { "lunghezza": 1040, "composizione": [260, 260, 260, 260] },
        { "lunghezza": 1060, "composizione": [260, 260, 260, 280] },
        { "lunghezza": 1080, "composizione": [260, 260, 280, 280] },
        { "lunghezza": 1100, "composizione": [260, 280, 280, 280] },
        { "lunghezza": 1120, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1140, "composizione": [280, 280, 280, 300] },
        { "lunghezza": 1160, "composizione": [280, 280, 300, 300] },
        { "lunghezza": 1180, "composizione": [280, 300, 300, 300] },
        { "lunghezza": 1200, "composizione": [300, 300, 300, 300] },
        { "lunghezza": 1220, "composizione": [300, 300, 300, 320] },
        { "lunghezza": 1240, "composizione": [300, 300, 320, 320] },
        { "lunghezza": 1260, "composizione": [300, 320, 320, 320] },
        { "lunghezza": 1280, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1300, "composizione": [260, 260, 260, 260, 260] },
        { "lunghezza": 1320, "composizione": [260, 260, 260, 260, 280] },
        { "lunghezza": 1340, "composizione": [260, 260, 260, 280, 280] },
        { "lunghezza": 1360, "composizione": [260, 260, 280, 280, 280] },
        { "lunghezza": 1380, "composizione": [260, 280, 280, 280, 280] },
        { "lunghezza": 1400, "composizione": [280, 280, 280, 280, 280] },
        { "lunghezza": 1420, "composizione": [280, 280, 280, 280, 300] },
        { "lunghezza": 1440, "composizione": [280, 280, 280, 300, 300] },
        { "lunghezza": 1460, "composizione": [280, 280, 300, 300, 300] },
        { "lunghezza": 1480, "composizione": [280, 300, 300, 300, 300] },
        { "lunghezza": 1500, "composizione": [300, 300, 300, 300, 300] },
        { "lunghezza": 1520, "composizione": [300, 300, 300, 300, 320] },
        { "lunghezza": 1540, "composizione": [300, 300, 300, 320, 320] },
        { "lunghezza": 1560, "composizione": [300, 300, 320, 320, 320] },
        { "lunghezza": 1580, "composizione": [300, 320, 320, 320, 320] },
        { "lunghezza": 1600, "composizione": [320, 320, 320, 320, 320] }
      ];
    }

  getDataProfili() {
      return [
        { "lunghezza": 20, "composizione": [80] },
        { "lunghezza": 40, "composizione": [80] },
        { "lunghezza": 60, "composizione": [80] },
        { "lunghezza": 80, "composizione": [80] },
        { "lunghezza": 100, "composizione": [120] },
        { "lunghezza": 120, "composizione": [120] },
        { "lunghezza": 140, "composizione": [160] },
        { "lunghezza": 160, "composizione": [160] },
        { "lunghezza": 180, "composizione": [200] },
        { "lunghezza": 200, "composizione": [200] },
        { "lunghezza": 220, "composizione": [240] },
        { "lunghezza": 240, "composizione": [240] },
        { "lunghezza": 260, "composizione": [280] },
        { "lunghezza": 280, "composizione": [280] },
        { "lunghezza": 300, "composizione": [320] },
        { "lunghezza": 320, "composizione": [320] },
        { "lunghezza": 340, "composizione": [160, 200] },
        { "lunghezza": 360, "composizione": [160, 200] },
        { "lunghezza": 380, "composizione": [200, 200] },
        { "lunghezza": 400, "composizione": [200, 200] },
        { "lunghezza": 420, "composizione": [200, 240] },
        { "lunghezza": 440, "composizione": [240, 240] },
        { "lunghezza": 460, "composizione": [240, 240] },
        { "lunghezza": 480, "composizione": [240, 240] },
        { "lunghezza": 500, "composizione": [240, 280] },
        { "lunghezza": 520, "composizione": [280, 280] },
        { "lunghezza": 540, "composizione": [280, 280] },
        { "lunghezza": 560, "composizione": [280, 280] },
        { "lunghezza": 580, "composizione": [280, 320] },
        { "lunghezza": 600, "composizione": [320, 320] },
        { "lunghezza": 620, "composizione": [320, 320] },
        { "lunghezza": 640, "composizione": [320, 320] },
        { "lunghezza": 660, "composizione": [240, 240, 200] },
        { "lunghezza": 680, "composizione": [240, 240, 200] },
        { "lunghezza": 700, "composizione": [240, 240, 240] },
        { "lunghezza": 720, "composizione": [240, 240, 240] },
        { "lunghezza": 740, "composizione": [240, 240, 280] },
        { "lunghezza": 760, "composizione": [280, 240, 240] },
        { "lunghezza": 780, "composizione": [280, 280, 240] },
        { "lunghezza": 800, "composizione": [280, 280, 240] },
        { "lunghezza": 820, "composizione": [280, 280, 280] },
        { "lunghezza": 840, "composizione": [280, 280, 280] },
        { "lunghezza": 860, "composizione": [280, 280, 320] },
        { "lunghezza": 880, "composizione": [280, 280, 320] },
        { "lunghezza": 900, "composizione": [320, 280, 320] },
        { "lunghezza": 920, "composizione": [320, 280, 320] },
        { "lunghezza": 940, "composizione": [320, 320, 320] },
        { "lunghezza": 960, "composizione": [320, 320, 320] },
        { "lunghezza": 980, "composizione": [240, 240, 240, 280] },
        { "lunghezza": 1000, "composizione": [240, 240, 280, 280] },
        { "lunghezza": 1020, "composizione": [240, 280, 280, 280] },
        { "lunghezza": 1040, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1060, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1080, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1100, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1120, "composizione": [280, 280, 280, 280] },
        { "lunghezza": 1140, "composizione": [280, 280, 280, 320] },
        { "lunghezza": 1160, "composizione": [280, 280, 320, 320] },
        { "lunghezza": 1180, "composizione": [280, 320, 320, 320] },
        { "lunghezza": 1200, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1220, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1240, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1260, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1280, "composizione": [320, 320, 320, 320] },
        { "lunghezza": 1300, "composizione": [320, 320, 320, 200, 160] },
        { "lunghezza": 1320, "composizione": [320, 320, 320, 200, 160] },
        { "lunghezza": 1340, "composizione": [320, 320, 320, 200, 200] },
        { "lunghezza": 1360, "composizione": [320, 320, 320, 200, 200] },
        { "lunghezza": 1380, "composizione": [320, 320, 320, 240, 200] },
        { "lunghezza": 1400, "composizione": [320, 320, 320, 240, 200] },
        { "lunghezza": 1420, "composizione": [320, 320, 320, 240, 240] },
        { "lunghezza": 1440, "composizione": [320, 320, 320, 240, 240] },
        { "lunghezza": 1460, "composizione": [320, 320, 320, 280, 240] },
        { "lunghezza": 1480, "composizione": [320, 320, 320, 280, 240] },
        { "lunghezza": 1500, "composizione": [320, 320, 320, 280, 280] },
        { "lunghezza": 1520, "composizione": [320, 320, 320, 280, 280] },
        { "lunghezza": 1540, "composizione": [320, 320, 320, 320, 280] },
        { "lunghezza": 1560, "composizione": [320, 320, 320, 320, 280] },
        { "lunghezza": 1580, "composizione": [320, 320, 320, 320, 320] },
        { "lunghezza": 1600, "composizione": [320, 320, 320, 320, 320] }
      ]
    }


}
